import { cn } from "@/lib/utils";

export interface InvoiceTotalsTableProps {
  /** Subtotal excluding GST (decimal dollars). */
  subtotalExGst: number;
  /** GST component (decimal dollars). */
  gst: number;
  /** Total including GST (decimal dollars). */
  totalIncGst: number;
  /** Outstanding balance after payments (decimal dollars). */
  balanceOutstanding: number;
  className?: string;
}

const fmt = new Intl.NumberFormat("en-AU", {
  style: "currency",
  currency: "AUD",
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

function formatAmount(n: number): string {
  return fmt.format(n);
}

export function InvoiceTotalsTable({
  subtotalExGst,
  gst,
  totalIncGst,
  balanceOutstanding,
  className,
}: InvoiceTotalsTableProps) {
  const rows: Array<{ label: string; value: number; emphasis?: boolean }> = [
    { label: "Subtotal (ex GST)",  value: subtotalExGst },
    { label: "GST",                value: gst },
    { label: "Total (inc GST)",    value: totalIncGst, emphasis: true },
    { label: "Balance Outstanding", value: balanceOutstanding, emphasis: true },
  ];

  return (
    <table className={cn("w-full max-w-sm text-sm", className)}>
      <tbody>
        {rows.map((row) => (
          <tr key={row.label} className="border-b last:border-b-0">
            <th
              scope="row"
              className={cn(
                "py-2 pr-4 text-left font-normal text-muted-foreground",
                row.emphasis && "font-medium text-foreground",
              )}
            >
              {row.label}
            </th>
            <td
              className={cn(
                "py-2 text-right tabular-nums",
                row.emphasis && "font-semibold",
              )}
            >
              {formatAmount(row.value)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
